var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "dropdown-body"
  }, [_c('div', {
    staticClass: "profile-menu-layout"
  }, [_c('section', {
    staticClass: "companies-section",
    attrs: {
      "aria-label": _vm.$t('sidebar.titles.company')
    }
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._v(_vm._s(_vm.$t('sidebar.titles.company')))]), _c('div', {
    staticClass: "companies-block"
  }, [_vm._l(_setup.mainCompanies, function (company) {
    return _c('SidedarCompanyItem', {
      key: company.id,
      attrs: {
        "companyId": company.id,
        "name": company.name,
        "photoUrl": company.photo,
        "isCurrent": _setup.checkIsCurrentCompany(company.id)
      },
      on: {
        "update-current": _setup.updateCurrentCompany
      }
    });
  }), _setup.defaultCompany ? _c('SidedarCompanyItem', {
    attrs: {
      "name": _setup.defaultCompany.name,
      "companyId": _setup.defaultCompany.id,
      "isCurrent": _setup.checkIsCurrentCompany(_setup.defaultCompany.id)
    },
    on: {
      "update-current": _setup.updateCurrentCompany
    }
  }) : _vm._e()], 2), _c('button', {
    staticClass: "add-company-container",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _setup.openNewCompanyModal
    }
  }, [_c('span', {
    staticClass: "add-company-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("+")]), _c('span', [_vm._v(_vm._s(_vm.$t('companies.addCompany')))])])]), _c('section', {
    staticClass: "profile-section"
  }, [_c('div', {
    staticClass: "profile-block"
  }, [_c('div', [_c('div', {
    staticClass: "dropdown-user-container d-flex align-items-center"
  }, [_c('div', [_vm.userPhoto ? _c('div', [_c('img', {
    staticClass: "rounded-circle d-block",
    attrs: {
      "width": "28px",
      "height": "28px",
      "src": _vm.userPhoto,
      "alt": "user-photo"
    }
  })]) : _c('div', [_c(_setup.DefaultPhotoSmall, {
    staticClass: "d-block",
    attrs: {
      "width": "28px",
      "height": "28px"
    }
  })], 1)]), _c('div', {
    staticClass: "user-details"
  }, [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.focus.noninteractive.ds500",
      modifiers: {
        "hover": true,
        "focus": true,
        "noninteractive": true,
        "ds500": true
      }
    }],
    staticClass: "user-name",
    attrs: {
      "title": _vm.userName,
      "tabindex": "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.userName) + " ")]), _vm.userRole ? _c('div', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.userRole))]) : _vm._e()]), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.focus.noninteractive.ds500",
      modifiers: {
        "hover": true,
        "focus": true,
        "noninteractive": true,
        "ds500": true
      }
    }],
    staticClass: "logout-button",
    attrs: {
      "type": "button",
      "disabled": _setup.logoutLoading,
      "aria-label": _vm.$t('header.titles.logout'),
      "title": _vm.$t('header.titles.logout')
    },
    on: {
      "click": _setup.logout
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "log-out",
      "viewBox": "0 0 24 24",
      "size": "20",
      "aria-hidden": "true"
    }
  })], 1)]), _vm._l(_setup.profilePagesItems, function (item) {
    return _c('router-link', {
      key: item.routeName,
      staticClass: "sidebar-dropdown-item",
      attrs: {
        "to": {
          name: item.routeName
        }
      },
      on: {
        "click": function ($event) {
          return _setup.chooseProfileItem();
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "action-chevron",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("›")])]);
  })], 2), _c('div', {
    staticClass: "preferences-block"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._v(" " + _vm._s(_vm.$t('sidebar.titles.settings')) + " ")]), _c('div', [_c('div', {
    staticClass: "theme-preference"
  }, [_c('div', {
    staticClass: "theme-options",
    attrs: {
      "role": "group",
      "aria-label": _vm.$t('uiTheme.label')
    }
  }, _vm._l(['light', 'dark', 'system'], function (theme) {
    return _c('button', {
      key: theme,
      staticClass: "theme-option",
      class: {
        selected: _setup.currentTheme === theme
      },
      attrs: {
        "type": "button",
        "aria-pressed": _setup.currentTheme === theme
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _setup.setTheme(theme);
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "aria-hidden": "true"
      }
    }, [theme === 'light' ? [_c('circle', {
      attrs: {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    }), _c('path', {
      attrs: {
        "d": "M12 2v2m0 16v2M2 12h2m16 0h2M4.93 4.93l1.42 1.42m11.3 11.3 1.42 1.42M4.93 19.07l1.42-1.42m11.3-11.3 1.42-1.42"
      }
    })] : theme === 'dark' ? _c('path', {
      attrs: {
        "d": "M20.9 13.3A9 9 0 0 1 10.7 3.1a9 9 0 1 0 10.2 10.2Z"
      }
    }) : [_c('rect', {
      attrs: {
        "x": "3",
        "y": "3",
        "width": "18",
        "height": "13",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M12 16v5m-4 0h8"
      }
    })]], 2), _c('span', [_vm._v(_vm._s(_vm.$t(`uiTheme.${theme}`)))])]);
  }), 0)]), _vm._t("locale-dropdown")], 2)])])])]), _c('NewCompanyModal', {
    attrs: {
      "modal-id": "newCompanyModal"
    },
    on: {
      "saved": _setup.companyCreated
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };